module.exports = __webpack_public_path__ + "static/media/img5.51d09211.jpg";